module.exports = __webpack_public_path__ + "img/1566885406.2d1bde1d.jpg";